// extracted by mini-css-extract-plugin
module.exports = {"link":"social-share_link_2rAOd"};